{
  "0_ALREADY_EXISTS": "\"{0}\" există deja.",
  "0_OF_1": "{0} din {1}",
  "ACCOUNT_ID": "ID cont",
  "ADD": "Adaugă",
  "ADD_REMOVE_FIELDS": "Adaugă/elimină câmpuri",
  "AN_ERROR_OCCURED": "A apărut o eroare",
  "APPLY": "Aplică",
  "APPLY_CHANGES": "Aplică modificările",
  "ATTACH": "Atașează",
  "ATTACH_AS_LINK": "Atașează ca link",
  "ATTACHING": "Atașare în curs...",
  "AUTOMATICALLY_RENAME": "Redenumește automat",
  "BACK": "Înapoi",
  "BROWSE": "Răsfoiește",
  "CANCEL": "Anulează",
  "CHARACTER_COUNT": "Număr de caractere:",
  "CLOSE": "Închide",
  "CLOUD": "Cloud",
  "COMMENT": "Comentariu",
  "CONFIGURE_REPOSITORY_SETTINGS": "Configurare setări depozit",
  "COULD_NOT_SAVE_0": "Nu s-a putut salva \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Nu s-a putut salva \"{0}\". Tipul fișierului nu este acceptat.",
  "DATA": "Date",
  "DATE": "Dată",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Câmpurile de dată trebuie să fie în formatul {0}.",
  "DATE_PROVIDED_IS_INVALID": "Data furnizată este invalidă.",
  "DATE_TIME": "Dată/Oră",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Câmpurile de dată/oră trebuie să fie în formatul {0}.",
  "DEFAULT_FOLDER": "<Folder Implicit>",
  "DETAILS": "Detalii",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Doriți să aplicați modificările câmpurilor?",
  "DOCUMENT_NAME_IS_EMPTY": "Numele documentului este gol",
  "DRAG_DROP_FILE": "Trageți și plasați fișierul",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "O intrare numită '{0}' există deja în acest dosar. Vă rugăm să selectați un nume diferit.",
  "ENTRY_ID": "ID intrare",
  "ENTRY_NAME": "Nume intrare",
  "ENTRY_NOT_FOUND": "Intrarea nu a fost găsită.",
  "ERROR_DOWNLOADING_DOCUMENT": "Eroare la descărcarea documentului.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "A apărut o eroare la conectarea la server.",
  "ERROR_SAVING": "Eroare la salvare:",
  "FAILED_TO_OPEN_FOLDER": "Deschiderea dosarului a eșuat",
  "FAILED_TO_SAVE_COLON": "Salvarea a eșuat:",
  "FAILED_TO_SAVE_PERIOD": "Salvarea a eșuat.",
  "FEEDBACK": "Feedback",
  "FIELDS": "Câmpuri",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Acest fișier depășește dimensiunea maximă permisă de 25MB.",
  "FILE_EXTENSION": "Extensie fișier",
  "FILE_LOCKED": "Fișierul este blocat.",
  "FILE_MODIFIED": "Fișier modificat",
  "FILE_NAME": "Nume fișier",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Numele fișierelor nu pot conține o bară inversă",
  "FOLDER": "Dosar",
  "INTEGER": "Întreg",
  "LIST": "Listă",
  "LOADING": "Se încarcă...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Câmpurile lungi trebuie să fie întregi între 0 și 3.999.999.999",
  "LONG_INTEGER": "Întreg lung",
  "NAME": "Nume",
  "NAME_CONFLICT": "Conflict de nume",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Aveți nevoie de ajutor pentru autentificare? Contactați administratorul Laserfiche pentru asistență.",
  "NEW_FOLDER": "Dosar nou",
  "NO": "Nu",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Nu sunt atribuite câmpuri suplimentare",
  "NO_FOLDER_SELECTED": "Niciun dosar nu este selectat.",
  "NO_MATCHING_ENTRIES_FOUND": "Nu au fost găsite intrări corespunzătoare",
  "NO_MATCHING_FIELDS_FOUND": "Nu au fost găsite câmpuri corespunzătoare.",
  "NO_TEMPLATE_ASSIGNED": "Niciun șablon atribuit",
  "NOT_AVAILABLE_WITH_TOKENS": "Nu este disponibil cu token-uri",
  "NUMBER": "Număr",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Câmpul numeric trebuie să fie un număr valid",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Unul sau mai multe câmpuri sunt invalide.",
  "OPEN": "Deschide",
  "OPEN_IN_LASERFICHE": "Deschide în Laserfiche",
  "OPTIONAL": "Opțional",
  "OR": "sau",
  "PARENT_FIELD": "Câmp părinte",
  "PARENT_ID": "ID părinte",
  "PARENT_NAME": "Nume părinte",
  "PLEASE_SELECT_A_FOLDER": "Vă rugăm să selectați un dosar",
  "REASON_FOR_DOWNLOADING": "Motivul descărcării",
  "REFRESH": "Reîmprospătează",
  "REMOVE": "Elimină",
  "REMOVE_REPOSITORY": "Eliminați depozitul?",
  "REPOSITORY": "Depozit",
  "REPOSITORY_COUNT": "Număr de depozite",
  "REPOSITORY_ID": "ID depozit",
  "REPOSITORY_NAME": "Numele depozitului",
  "REQUIRED": "Obligatoriu",
  "REQUIRED_FIELD_IS_EMPTY": "Câmpul obligatoriu este gol",
  "SAVE_CHANGES": "Salvează modificările",
  "SAVE_TO_LASERFICHE": "Salvează în Laserfiche",
  "SAVED_TO_LASERFICHE": "Salvat în Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Salvat în Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Salvat cu metadate lipsă:",
  "SAVING": "Se salvează...",
  "SEARCH_FIELDS": "Câmpuri de căutare",
  "SELECT": "Selectează",
  "SELECT_REASON": "Selectați un motiv",
  "SELF_HOSTED": "Auto-găzduit",
  "SESSION_COUNT": "Număr sesiuni",
  "SETTINGS": "Setări",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Câmpurile scurte trebuie să fie întregi între 0 și 64999",
  "SIGN_IN": "Autentificare",
  "SIGN_IN_TO_LASERFICHE": "Autentificare în Laserfiche",
  "SIGN_OUT": "Deconectare",
  "SIGNING_IN": "Autentificare în curs...",
  "SIGNING_OUT": "Deconectare în curs...",
  "SKIP_THIS_FILE": "Sari peste acest fișier",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Ceva nu a mers bine. Vă rugăm să încercați din nou mai târziu.",
  "SUBMIT": "Trimite",
  "SUGGESTION": "Sugestie",
  "TEMPLATE": "Șablon",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Șablonul nu a putut fi încărcat.",
  "TEXT": "Text",
  "THANK_YOU_FOR_SUBMISSION": "Vă mulțumim pentru trimitere!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Acest câmp are o lungime maximă permisă de {0} caractere.",
  "THIS_FOLDER_IS_EMPTY": "Acest dosar este gol.",
  "TIME": "Timp",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Câmpurile de timp trebuie să fie în formatul {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Nu s-au putut încărca toate câmpurile:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Nu se pot prelua informațiile despre depozit:",
  "UNKNOWN_ERROR": "Eroare necunoscută.",
  "USER_NAME": "Nume utilizator",
  "YES": "Da"
}
